import { Injectable } from '@angular/core';

@Injectable()
export class PortalMenuService {
  modulesConfig = {
    header: {
      self: {},
      items: [{}],
    },
    aside: {
      items: [
        {
          title: 'Content Management',
          page: '/cms',
          icon: '/assets/images/icons/content-management-systems.svg',
        },

        {
          title: 'Deployment Management',
          page: '/dms',
          icon: '/assets/images/icons/deployment.svg',
        },

        {
          title: 'POC Administration ',
          page: '/poc',
          icon: '/assets/images/icons/hospital.svg',
        },
        /*  {
            product_id: 9340,
            title: 'Prescribe',
            page: '/prescribe',
            icon: '/assets/images/icons/hcp-clipboard-with-pencil.svg',
          }, */
        /* {
           product_id: 8991,
           title: 'Interactive Tablet',
           page: '/it',
           icon: '/assets/images/icons/hcp-tablet-icon.svg',
         }, */
        /*  {
            product_id: 10649,
            title: 'Nabed TV',
            page: '/tv',
            icon: '/assets/images/icons/hcp-monitor-icon.svg',
          }, */
        /* {

           title: 'Financials',
           page: '/financial',
           icon: '/assets/images/icons/hcp-five-coins-stack.svg',
         }, */

        /* {
           title: 'Devices Monitoring',
           page: '/devices',
           icon: '/assets/images/icons/hcp-monitor-settings.svg',
         }, */
        /*  {
            title: 'Users Management',
            page: '/users',
            icon: '/assets/images/icons/hcp-user-settings.svg',
          }, */
      ],
    },
    product: {
      name: 'Nabed Platform © 2020',
      version: 'Nabed v.1.1',
    },
  };

  // constructor(private menuConfig: MenuConfigService, private router: Router) {}

  public init(): void {
    // this.menuConfig.setModel(new MenuConfig(this.modulesConfig));
  }

  public setHeaders(): void {
    // objectPath.set(this.modulesConfig, 'header.items', objectPath.get(this.pagesConfig, `${page}.items`));
  }
}
